import React, { useState } from 'react';
import Head from 'next/head';
import Link from 'next/link';

export default function Widget() {
  const [searchtxt, setSearchtxt] = useState('');

  function handleSearchWidget(value) {
    if (searchtxt != '') {
      window.open(
        `${process.env.WEBSITE_URL}thuat-ngu?text=${searchtxt}`,
        '_blank', // <- This is what makes it open in a new window.
      );
    } else {
      window.open(
        process.env.WEBSITE_URL,
        '_blank', // <- This is what makes it open in a new window.
      );
    }
  }

  return (
    <React.Fragment>
      <Head>
        <title>Thuật ngữ VietnamBiz</title>
        <meta name="description" content="Thuật ngữ VietnamBiz" />
        <meta property="og:title" content="Thuật ngữ VietnamBiz" />
        <meta property="og:description" content="Thuật ngữ VietnamBiz" />
        <meta property="og:image" content={`${process.env.WEBSITE_URL}static/img/logo/vnbz-300x300.png`} />
        <meta property="og:url" content={process.env.WEBSITE_URL} />
        <meta property="og:site_name" content="Thuật ngữ VietnamBiz" />
      </Head>

      <div className="widget__thuatngu__box">
        <div className="widget__thuatngu">
          <div className="widget__thuatngu__header">
            <div className="cluster__heading is__dash__left mb-0">
              <h2 className="cluster__title text-uppercase">
                Tra cứu thuật ngữ <br className="d-none d-md-inline" />
                kinh tế
              </h2>
            </div>
          </div>
          <div className="widget__thuatngu__body">
            <form onSubmit={() => handleSearchWidget(searchtxt)}>
              <div className="widget__thuatngu__form">
                <input
                  type="text"
                  className="form-control widget__thuatngu__input search-quick-input"
                  value={searchtxt}
                  onChange={e => setSearchtxt(e.target.value)}
                  placeholder="Bạn cần tìm thuật ngữ gì ..."
                  aria-label
                  aria-describedby
                  name="q"
                />
                <button className="btn btn-primary-2 widget__thuatngu__btn" type="submit">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="svg-icon fill-current">
                    <path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z" />
                  </svg>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* <div class="iframe-thuatngu">
      <iframe
        src="http://localhost:3000/widget-thuatngu.html"
        width="100%"
        title=""
        frameborder="0"
      ></iframe>
    </div>

    <style>
      .iframe-thuatngu iframe {
        height: 80px;
      }
      @media (max-width: 991.98px) {
        .iframe-thuatngu iframe {
          height: 111px;
        }
      }
    </style> */}
    </React.Fragment>
  );
}
